import {z} from '@hono/zod-openapi';

import {priceReportArgumentDirectionSchema} from './PriceReportArgumentDirectionSchema';
import {priceReportArgumentFactKeySchema} from './PriceReportArgumentFactKeySchema';

/**
 * One deterministic fact computed from a Price Report. Arguments may only quote numbers that
 * appear in `displayValue`, `displayBenchmark`, `displayDelta` or `details` of the facts they cite.
 */
export const priceReportArgumentFactSchema = z
  .object({
    id: z.string(),
    key: priceReportArgumentFactKeySchema,
    // English description for the model; the app translates facts by `key`.
    label: z.string(),
    value: z.number().nullable(),
    benchmark: z.number().nullable(),
    // Localized, already formatted values.
    displayValue: z.string(),
    displayBenchmark: z.string().nullable(),
    displayDelta: z.string().nullable(),
    details: z.string().nullable(),
    sampleSize: z.number().nullable(),
    // Catalogue codes of the features an equipment fact lists, so the app shows its own labels.
    catalogueCodes: z.array(z.string()).nullish(),
    direction: z.object({
      selling: priceReportArgumentDirectionSchema,
      buying: priceReportArgumentDirectionSchema,
    }),
    strength: z.number(),
  })
  .openapi('PriceReportArgumentFact');

export type PriceReportArgumentFact = z.infer<typeof priceReportArgumentFactSchema>;
